import axios from "axios";
import { getCookieValue, postToNativeApp } from "../common/helpers";
import { addTimestampToUrl, getAccessToken, getXrefToken } from "../utils";
import { ILogDto } from "../utils/log.dto";
import { refreshTokenRequest } from "../utils/tokenService";
import Constants from "../constants/Constants";

axios.defaults.headers =
	{
		'Cache-Control': 'no-cache',
		'Pragma': 'no-cache',
		'Expires': '0',
	} as any;

const API = process.env.REACT_APP_BASE_URL;
const NETWORK_HOSPITAL_API = process.env.REACT_APP_NETWORK_HOSPITAL_URL;

axios.interceptors.response.use(response => {
	return response;
}, error => {
	if (error.response.status === 401 || error.response.status === 403) {
			if (getCookieValue('source') === 'native') {
				postToNativeApp({ TOKEN_EXPIRED: true });
			}
			else {
			refreshTokenRequest()
			}
	}
	return error.response;
});

function getHeaders() {
	return {
		'accept': 'application/json',
		'accesstoken': getAccessToken(),
		'x-ref-token': getXrefToken()
	};
}

function postHeaders() {
	return {
		'content-type': 'application/json',
		'accesstoken':getAccessToken(),
		'x-ref-token': getXrefToken()
	};
}

function patchHeaders() {
	return {
		'content-type': 'application/json',
		'accesstoken': getAccessToken(),
		'x-ref-token': getXrefToken()
	};
}

function putHeaders() {
	return {
		'content-type': 'application/json',
		'accesstoken': getAccessToken(),
		'x-ref-token': getXrefToken()
	};
}

function deleteHeaders() {
	return {
		'content-type': 'application/json',
		'accesstoken': getAccessToken(),
		'x-ref-token': getXrefToken()
	};
}

function postNetWork() {
	return {
        "Content-Type": "application/json",
        "Authorization": Constants.Instance.AUTHORIZATION_NETWORK
	}
}

export const postRequest = <T>(endpoint: string, data: T) => {
	let url = API + endpoint;
	url = addTimestampToUrl(url);
	return axios.post(url, data, { headers: postHeaders() });
}

export const postRequestHospital = <T>(endpoint: string, request: T) => {
	let url = NETWORK_HOSPITAL_API + endpoint;
    return axios.post(url, request, {
        headers: postNetWork(),
    })
    .then((response) => response.data)
    .catch((err) => {
        console.error(err);
        throw err; 
    });
};

export const patchRequest = <T>(endpoint: string, data: T) => {
	let url = API + endpoint;
	url = addTimestampToUrl(url);
	return axios.patch(url, data, { headers: patchHeaders() });
}

export const putRequest = <T>(endpoint: string, data: T) => {
	let url = API + endpoint;
	url = addTimestampToUrl(url);
	return axios.put(url, data, { headers: putHeaders() });
}

export const getRequest = (endpoint: string) => {
	let url = API + endpoint;
	url = addTimestampToUrl(url);
	return axios.get(url, { headers: getHeaders() });
}

export const getBlobRequest = (endpoint: string) => {
	let url = API + endpoint;
	url = addTimestampToUrl(url);
	return axios.get(url, { headers: getHeaders(), responseType:"blob" });
}

export const postBlobRequest = <T>(endpoint: string, data: T) => {
	let url = API + endpoint;
	url = addTimestampToUrl(url);
	return axios.post(url, data, { headers: postHeaders(), responseType: "blob" });
}

export const deleteRequest = (endpoint: string) => axios
	.delete(API + endpoint, { headers: deleteHeaders() })    